import React from "react";

function LeagueFilters({ filters, onChange }) {
	const handleChange = (event) => {
		onChange({
			...filters,
			activesOnly: event.target.value === "true",
		});
	};

	return (
		<div className='card mb-4'>
			<div className='card-body'>
				<div className='row align-items-end'>
					<div className='col-12 col-md-4'>
						<label className='form-label' htmlFor='activesOnly'>
							Solo activos
						</label>
						<select
							className='form-select'
							id='activesOnly'
							onChange={handleChange}
							value={String(filters.activesOnly)}
						>
							<option value='false'>false</option>
							<option value='true'>true</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	);
}

export default LeagueFilters;